import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useLanguage } from '../contexts/LanguageContext'; // Assuming you have this for translations
// Import translations if you have specific ones for this page
// import { translations } from '../translations';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const { language } = useLanguage(); // For potential translations
  // const t = translations[language].forgotPassword; // If you have translations

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      // Provide more specific success message based on language
      setMessage(language === 'nl' ? `Een link om je wachtwoord opnieuw in te stellen is verzonden naar ${email}. Controleer je inbox (en spamfolder).` : `A password reset link has been sent to ${email}. Please check your inbox (and spam folder).`);
    } catch (err: any) {
      console.error("Error sending password reset email:", err);
      // Provide more specific error message based on language
      setError(language === 'nl' ? 'Fout bij het verzenden van de wachtwoordherstellink. Controleer het e-mailadres of probeer het later opnieuw.' : 'Failed to send password reset link. Please check the email address or try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ mt: 8, mb: 4 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          {language === 'nl' ? 'Wachtwoord Vergeten' : 'Forgot Password'} 
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1, mb: 3 }}>
          {language === 'nl' ? 'Voer je e-mailadres in om een link te ontvangen waarmee je je wachtwoord opnieuw kunt instellen.' : 'Enter your email address below and we will send you a link to reset your password.'}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={language === 'nl' ? 'E-mailadres' : 'Email Address'}
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          {message && (
            <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
              {error}
            </Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? (language === 'nl' ? 'Bezig met verzenden...' : 'Sending...') : (language === 'nl' ? 'Verstuur Herstellink' : 'Send Reset Link')}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword; 